import { Select } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { EmpresaProcurador } from '../../constants';

const { Representacao } = EmpresaProcurador;

export default function SelectEmpresaProcuradorRepresentacao(props) {
  const { t } = useTranslation();

  const createOption = ({ id, label }) => (
    <Select.Option value={id}>
      {t(label)}
    </Select.Option>);

  return (
    <Select {...props} >
      {createOption(Representacao.Isolada)}
      {createOption(Representacao.Conjunta)}
      {createOption(Representacao.Mista)}
    </Select>
  );
}

SelectEmpresaProcuradorRepresentacao.propTypes = {
  value: PropTypes.oneOf([
    Representacao.Isolada.id,
    Representacao.Conjunta.id,
    Representacao.Mista.id,
  ]),
  onChange: PropTypes.func,
};
